export default "__VITE_ASSET__o2uZlSzx__"